import {apiGlobal} from './index'
import {LOCAL_STORAGE} from '@utils/Const'

const getAccessToken = () => localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)
const getUserId = () => localStorage.getItem(LOCAL_STORAGE.USER_ID)

export const notebookEndPoints = {
  GET_FOLDER: 'iesv/api/v1/knowledge-notebooks/folders', // lấy danh sách folder
  GET_FOLDER_OPEN: 'iesv/api/v1/open/knowledge-notebooks/folders', // lấy danh sách folder
  GET_FOLDER_PHRASE: 'iesv/api/v1/knowledge-notebooks/folders/save-phrases', // lấy danh sách folder lưu cụm
  GET_FOLDER_PHRASE_OPEN:
    'iesv/api/v1/open/knowledge-notebooks/folders/save-phrases', // lấy danh sách folder lưu cụm
  CREATE_FOLDER: 'iesv/api/v1/knowledge-notebooks/folders', // Tạo folder
  CREATE_FOLDER_OPEN: 'iesv/api/v1/open/knowledge-notebooks/folders', // Tạo folder
  GET_DETAIL_FOLDER: 'iesv/api/v1/knowledge-notebooks/folders', // Lấy danh sách trong 1 folder
  GET_ALL_SENTENCE:
    'iesv/api/v1/knowledge-notebooks/folders/knowledge-buckets/all-sentences', // lấy folder tất cả mẫu câu
  GET_DETAIL_KNOWLEDGE: 'iesv/api/v1/knowledge-notebooks/knowledge-buckets',
  SAVE_PHRASE: 'iesv/api/v1/knowledge-notebooks/knowledge-buckets/phrases', // Lưu cụm từ
  SAVE_PHRASE_OPEN:
    'iesv/api/v1/open/knowledge-notebooks/knowledge-buckets/phrases', // Lưu cụm từ
  SAVE_SENTENCE: 'iesv/api/v1/knowledge-notebooks/knowledge-buckets/sentences', // Lưu câu
  SAVE_SENTENCE_OPEN:
    'iesv/api/v1/open/knowledge-notebooks/knowledge-buckets/sentences', // Lưu câu
  CHECK_RECENTLY_SAVED_FOLDER:
    'iesv/api/v1/knowledge-notebooks/knowledge-buckets/phrases/recently-saved-folders',
}

const notebookRequest = {
  getFolder: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(`${notebookEndPoints.GET_FOLDER}`, params)
    }
    return apiGlobal.get(
      `${notebookEndPoints.GET_FOLDER_OPEN}`,
      params,
    )
  },
  getFolderSavePhrase: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(`${notebookEndPoints.GET_FOLDER_PHRASE}`, params)
    }
    return apiGlobal.get(`${notebookEndPoints.GET_FOLDER_PHRASE_OPEN}`, params)
  },
  createFolder: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(notebookEndPoints.CREATE_FOLDER, params)
    }
    return apiGlobal.post(
      `${notebookEndPoints.CREATE_FOLDER_OPEN}`,
      params,
    )
  },
  getDetailFolder: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${notebookEndPoints.GET_DETAIL_FOLDER}/${params}/knowledge-buckets`,
        {},
      )
    }
  },
  getAllSentence: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(`${notebookEndPoints.GET_ALL_SENTENCE}`, {})
    }
  },
  getDetailPhrases: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${notebookEndPoints.GET_DETAIL_KNOWLEDGE}/${params.folderId}/phrases/${params.phraseBucketId}`,
        {},
      )
    }
  },
  getDetailSentence: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${notebookEndPoints.GET_DETAIL_KNOWLEDGE}/${params.folderId}/sentences/${params.sentencesBucketId}`,
        {},
      )
    }
  },
  savePhrase: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(`${notebookEndPoints.SAVE_PHRASE}`, params)
    }
    return apiGlobal.post(
      `${notebookEndPoints.SAVE_PHRASE_OPEN}`,
      params,
    )
  },
  saveSentence: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(`${notebookEndPoints.SAVE_SENTENCE}`, params)
    }
    return apiGlobal.post(
      `${notebookEndPoints.SAVE_SENTENCE_OPEN}`,
      params,
    )
  },
  checkRecentlySavedFolder: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${notebookEndPoints.CHECK_RECENTLY_SAVED_FOLDER}`,
        params,
      )
    }
  },
}

export default notebookRequest
